<template>
  <div
    class="in-player-panel"
    :style="{width: realWidth,height: realHeight, maxWidth: maxWidth+'px'}">
    <div class="in-player" :class="{'is-out-course': outCourse}" :id="playerId"></div>
  </div>
</template>

<script type="text/ecmascript-6">
const jsPath = '//g.alicdn.com/de/prismplayer/2.8.1/aliplayer-h5-min.js'
const cssPath = '//g.alicdn.com/de/prismplayer/2.8.1/skins/default/aliplayer-min.css'

// 视频的长宽比例，采用 width / height 得到，基本按照 16:9 获取
export default {
  name: 'in-player',
  props: {
    width: Number,
    maxWidth: Number,
    height: Number,
    useEncrypt: Boolean,
    playAuth: String,
    source: String,
    videoId: String,
    region: {
      type: String,
      default: 'cn-shanghai'
    },
    userRatio: {
      type: Number,
      default: 16 / 9
    },
    outCourse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ratio: null,
      defaultWidth: 1092,
      defaultHeight: 614,
      playerId: 'inPlayer' + (+new Date()),
      // 播放器实例
      inPlayer: null,
      defaultOption: {
        useH5Prism: true,
        isLive: false,
        // source: JSON.stringify({ 'HD': '//player.alicdn.com/resource/player/qupai.mp4', 'SD': '//player.alicdn.com/resource/player/qupai.mp4' }),
        autoplay: false,
        // 'encryptType': 1,
        playsinline: false,
        preload: true,
        controlBarVisibility: 'hover',
        // language: 'en-us',
        useHlsPluginForSafari: 'true',
        skinLayout: [
          { name: 'bigPlayButton', align: 'cc', x: 30, y: 80 },
          { name: 'H5Loading', align: 'cc' },
          { name: 'infoDisplay' },
          { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
          { name: 'thumbnail' },
          { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
          {
            name: 'controlBar',
            align: 'blabs',
            x: 0,
            y: 0,
            children: [
              { name: 'speedButton', align: 'tr', x: 10, y: 23 },
              { name: 'progress', align: 'blabs', x: 0, y: 44 },
              { name: 'playButton', align: 'tl', x: 15, y: 12 },
              { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
              { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
              { name: 'setting', align: 'tr', x: 15, y: 12 },
              { name: 'volume', align: 'tr', x: 5, y: 10 }
            ]
          }
        ]
      },
      clickDelayTimer: null
    }
  },
  watch: {
    source (newVal, oldVal) {
      if (this.useEncrypt === false && newVal) {
        if (oldVal === null) {
          this._initialize()
        } else {
          this.changePlayAuth()
        }
      }
    },
    playAuth (newVal, oldVal) {
      if (this.useEncrypt && newVal) {
        if (!oldVal) {
          this._initialize()
        } else {
          this.changePlayAuth()
        }
      }
    },
    realWidth (value) {
      if (this.inPlayer && !this.outCourse) {
        this.inPlayer.setPlayerSize(value, this.realHeight)
      }
    },
    realHeight (value) {
      if (this.inPlayer && !this.outCourse) {
        this.inPlayer.setPlayerSize(this.realWidth, value)
      }
    }
  },
  computed: {
    realWidth () {
      return this.outCourse ? 'unset' : `${(this.height || this.defaultHeight) * this.ratio}px`
    },
    realHeight () {
      return this.outCourse ? '100%' : `${(this.width || this.defaultWidth) / this.ratio}px`
    }
  },
  mounted () {
    this.ratio = this.userRatio
    this.$nextTick(() => {
      if (this.playAuth || this.source) {
        this._initialize()
      }
    })
  },
  methods: {
    _initialize () {
      // 判断播放器全局实例是否已存在，只有当播放器依赖的 JS 加载完成后，播放器的全局实例才存在
      if (!window.Aliplayer) {
        let inPlayerScriptTag = document.getElementById('inPlayerScriptTag')

        // 判断JS是否已存在
        if (!inPlayerScriptTag) {
          inPlayerScriptTag = document.createElement('script')
          inPlayerScriptTag.type = 'text/javascript'
          inPlayerScriptTag.src = jsPath
          // 指定 JS 的 ID
          inPlayerScriptTag.id = 'inPlayerScriptTag'

          const inPlayerLinkTag = document.createElement('link')
          inPlayerLinkTag.type = 'text/css'
          inPlayerLinkTag.rel = 'stylesheet'
          inPlayerLinkTag.href = cssPath

          const head = document.getElementsByTagName('head')[0]
          head.appendChild(inPlayerScriptTag)
          head.appendChild(inPlayerLinkTag)
        }

        if (inPlayerScriptTag.loaded) {
          this._initPlayer()
        } else {
          inPlayerScriptTag.addEventListener('load', () => {
            this._initPlayer()
          })
        }
      } else {
        this._initPlayer()
      }
    },
    _initPlayerInstance (options) {
      const params = Object.assign({}, this.defaultOption, options, {
        id: this.playerId,
        width: this.realWidth,
        height: this.realHeight,
        region: this.region
      })
      this.inPlayer = window.Aliplayer(params, player => {
        this.$emit('loaded-video', player)
      })

      // video Events
      const a = document.getElementById(this.playerId).getElementsByTagName('video')[0]
      a.addEventListener('click', this.clickVideo)
      a.addEventListener('dblclick', this.dblClickVideo)
      window.addEventListener('keydown', this.keydown)

      this.inPlayer.on('error', e => {
        const paramData = e.paramData
        const w = document
        const pdiEle = w.querySelector('.prism-detect-info')
        pdiEle && pdiEle.parentNode.removeChild(pdiEle)
        const peoEle = w.querySelector('.prism-error-operation')
        peoEle && peoEle.parentNode.removeChild(peoEle)
        if (paramData.error_code === 4010 || paramData.error_code === 4011 || paramData.error_code === 4013) {
          w.querySelector('.prism-error-content p').innerHTML = 'not surport'
        } else if (paramData.error_code === 4400 || paramData.error_code === 4500) {
          w.querySelector('.prism-error-content p').innerHTML = 'Try refresh later please'
        } else {
          w.querySelector('.prism-error-content p').innerHTML = 'Try refresh later please'
          w.querySelector('.prism-ErrorMessage').style.display = 'block'
        }
      })
      window.player = this.inPlayer
      if (this.$route.name === 'live') {
        this.$parent.setApliplayerEvents()
      }
    },
    _initPlayer () {
      if (!this.inPlayer) {
        if (this.useEncrypt) {
          // 初始化播放器
          this._initPlayerInstance({
            playauth: this.playAuth,
            useEncrypt: this.useEncrypt,
            vid: this.videoId,
            encryptType: 1
          })
        } else {
          try {
            this._initPlayerInstance({
              source: this.source
            })
          } catch (error) {
            console.error(error)
          }
        }
      } else {
        const a = document.getElementById(this.playerId).getElementsByTagName('video')[0]
        a.removeEventListener('click', this.clickVideo)
        a.removeEventListener('dblclick', this.dblClickVideo)
        this.inPlayer.dispose()
        this.inPlayer = null
        document.getElementById(this.playerId).innerHTML = ''

        // 再次初始化
        this._initPlayer()
      }
    },
    // 更新播放地址
    changePlayAuth () {
      // 重新初始化
      this._initPlayer()
    },
    play (a) {
      clearTimeout(this.clickDelayTimer)
      if (a === 'ready' || a === 'pause') {
        this.clickDelayTimer = setTimeout(() => {
          if (this.inPlayer) this.inPlayer.play()
        }, 200)
      } else if (a === 'ended') {
        this.clickDelayTimer = setTimeout(() => {
          if (this.inPlayer) this.inPlayer.replay()
        }, 200)
      }
    },
    pause () {
      clearTimeout(this.clickDelayTimer)
      this.clickDelayTimer = setTimeout(() => {
        if (this.inPlayer) this.inPlayer.pause()
      }, 200)
    },
    keydown (e) {
      if (e.keyCode === 32) {
        if (e.target.nodeName === 'TEXTAREA' || e.target.nodeName === 'INPUT') {
          return
        }
        e.preventDefault()
        this.clickVideo()
      }
    },
    clickVideo (e) {
      const a = this.inPlayer.getStatus()
      if (a === 'ready' || a === 'pause' || a === 'ended') {
        this.play(a)
      } else if (a === 'playing') {
        this.pause()
      }
    },
    dblClickVideo (e) {
      clearTimeout(this.clickDelayTimer)
      if (this.inPlayer) {
        if (this.inPlayer.fullscreenService.getIsFullScreen()) {
          this.inPlayer.fullscreenService.cancelFullScreen()
        } else {
          this.inPlayer.fullscreenService.requestFullScreen()
        }
      }
    }
  },
  beforeDestroy () {
    const $container = document.getElementById(this.playerId)
    if ($container) {
      const a = $container.getElementsByTagName('video')[0]
      if (a) {
        a.removeEventListener('click', this.clickVideo)
        a.removeEventListener('dblclick', this.dblClickVideo)
      }
    }
  },
  destroyed () {
    if (this.inPlayer) {
      this.inPlayer.dispose()
      this.inPlayer = null
    }
    window.removeEventListener('keydown', this.keydown)
    const $container = document.getElementById(this.playerId)
    if ($container) {
      $container.innerHTML = ''
    }
  }
}
</script>

<style lang="scss">

  .in-player-panel {
    display: flex;
    flex-direction: column;
    background: rgba(216, 216, 216, 1);

    .prism-player .prism-controlbar .prism-controlbar-bg {
      background: rgba(0, 0, 0, .5);
    }

    .in-player {
      flex-grow: 1;
      border-bottom: none;
      border-radius: 2px;
      overflow: hidden;

      &.is-out-course {
        position: absolute;
        width: 100% !important;
        height: 100% !important;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
  }

</style>
